import themes from './toastThemes';

const toastHeaders = {
	[themes.toastThemes.CONFIRM_SUCCESS]: 'Merci pour votre confirmation',
	[themes.toastThemes.ERROR_OCCURED]: 'Une erreur est survenue',
};

export default toastHeaders;
